import React from "react";
import "../BottomContainer.css"; // Import CSS for styling

function BottomContainer({ children }) {
  return <div className="bottom-container">{children}</div>;
}

export default BottomContainer;
